enum DecoratorTypes {
    Displayable = 'displayable',
    Required = 'required',
}

export default DecoratorTypes
